import { TFormFieldData } from '@gismart/ui.library/core/types'

export const getVariantsIndexesWithUids = (
  fields: TFormFieldData[],
): [number, string][] =>
  fields
    .filter((field) => field.name[1] === 'uid')
    .map((field) => [parseInt(field.name[0], 10), field.value])
